<template>
    <div>
        <!-- 发布和保存 -->
        <div class="button-list" v-if="detailData.category_status == 10 || task_id == 0">
            <div class="front-btn green" @click="save">保存</div>
            <div class="front-btn green" @click="release">发布</div>
        </div>

        <!-- 发布方 -->
        <div class="button-list" v-if="buType == 1 && detailData.category_status == 20 && detailData.process_status == 204">
            <div class="front-btn green" @click="review_complete">通过</div>
            <div class="front-btn" @click="pop.review_rejectFlag = true">不通过</div>
        </div>
        <div class="button-list" v-if="buType == 1 && detailData.category_status == 20 && detailData.process_status == 205">
            <div class="front-btn green" @click="cancel_agree">通过</div>
            <div class="front-btn" @click="pop.cancelRejectFlag = true">不通过</div>
        </div>
        <div class="button-list" v-if="buType == 1 && detailData.category_status == 20 && detailData.process_status == 202">
            <div class="front-btn red" @click="pop.reportFlag = true">投诉</div>
            <div class="front-btn red" @click="stop_task">终止</div>
        </div>

        <!-- 接收方 -->
        <div class="button-list" v-if="buType == 2 && detailData.category_status == 20 && detailData.process_status == 201">
            <div class="front-btn green" @click="receive">接收</div>
            <div class="front-btn red" @click="pop.refuseFlag = true">拒绝</div>
        </div>
        <div class="button-list" v-if="buType == 2 && detailData.category_status == 20 && detailData.process_status == 203">
            <div class="front-btn green" @click="review">提交验收</div>
            <div class="front-btn red" @click="pop.cancelFlag = true">申请取消</div>
        </div>


        <!--**********弹窗分界线******************-->

        <!--拒绝任务-->
        <el-dialog @open="openFocus('area_refuse')" @close="pop.refuseReason = ''" title="拒绝任务" :visible.sync="pop.refuseFlag">
            <div class="form-item">
                <div class="item-title">任务编号：</div>
                <div class="item-text">{{ detailData.code }}</div>
            </div>
            <div class="form-item">
                <div class="item-title">任务名称：</div>
                <div class="item-text">{{ detailData.task_name }}</div>
            </div>
            <div class="form-item">
                <div class="item-title must">拒绝原因：</div>
                <div class="item-wrap">
                    <textarea :class="{'z-error':pop.refuseTip}" @focus="pop.refuseTip=false" ref="area_refuse" id="area_refuse" v-model="pop.refuseReason"></textarea>
                    <transition name="fade">
                        <div v-show="pop.refuseTip" class="tip">请输入拒绝原因</div>
                    </transition>
                </div>
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="pop.refuseFlag = false">取 消</el-button>
                <el-button type="primary" @click="confirm_refuse">确 定</el-button>
            </div>
        </el-dialog>

        <!--流转任务-->
        <!-- <el-dialog  @close="pop.transBuId = ''" title="流转任务" :visible.sync="pop.transFlag">
            <div class="form-item">
                <div class="item-title">任务编号：</div>
                <div class="item-text">{{ detailData.id_number }}</div>
            </div>
            <div class="form-item">
                <div class="item-title">任务名称：</div>
                <div class="item-text">{{ sub_taskName }}</div>
            </div>
            <div class="form-item auto">
                <div class="item-title must">流转BU：</div>
                <div class="item-text">
                     <el-select  v-model="pop.transBuId" placeholder="请选择">
                        <el-option v-for="item in buChooseList" :key="item.id" :label="item.bu_name" :value="item.id">
                        </el-option>
                    </el-select> 
                </div> -->
                 <!-- <div class="item-wrap">
                    <div class="type bu">
                        <div class="listDown" @mouseleave="pop.transOpen = false">
                            <p @click="pop.transOpen = true" :class="{listUp:pop.transOPen,choose:pop.transBuId}">{{transBuName}}</p>
                            <ul class="type-list" v-show="pop.transOpen" >
                                <li @click="()=>{pop.transBuId = item.id;pop.transOpen = false; }"  :key="item" v-for="(item,index) in buChooseList" :class="{active:item.bu_name == transBuName}">{{item.bu_name}}</li>
                            </ul>
                        </div>
                    </div> 
                </div> -->
            <!-- </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="pop.transFlag = false">取 消</el-button>
                <el-button type="primary" @click="confirm_trans">确 定</el-button>
            </div>
        </el-dialog> -->

         <!--任务投诉-->
        <el-dialog @open="openFocus('area_report')" @close="pop.reportReason = ''" title="任务投诉" :visible.sync="pop.reportFlag">
            <div class="form-item">
                <div class="item-title">任务编号：</div>
                <div class="item-text">{{ detailData.code }}</div>
            </div>
            <div class="form-item">
                <div class="item-title">任务名称：</div>
                <div class="item-text">{{ detailData.task_name }}</div>
            </div>
            <div class="form-item">
                <div class="item-title must">投诉原因：</div>
                <div class="item-wrap">
                    <textarea :class="{'z-error':pop.reportTip}" @focus="pop.reportTip=false" ref="area_report" v-model="pop.reportReason"></textarea>
                    <transition name="fade">
                        <div v-show="pop.reportTip" class="tip">请输入投诉原因</div>
                    </transition>
                </div>
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="pop.reportFlag = false">取 消</el-button>
                <el-button type="primary" @click="confirm_report">确 定</el-button>
            </div>
        </el-dialog>

        <!--申请取消任务-->
        <el-dialog @open="openFocus('area_cancel')" @close="pop.cancelReason = ''" title="任务取消" :visible.sync="pop.cancelFlag">
            <div class="form-item">
                <div class="item-title">任务编号：</div>
                <div class="item-text">{{ detailData.code }}</div>
            </div>
            <div class="form-item">
                <div class="item-title">任务名称：</div>
                <div class="item-text">{{ detailData.task_name }}</div>
            </div>
            <div class="form-item">
                <div class="item-title must">取消原因：</div>
                <div class="item-wrap">
                    <textarea :class="{'z-error':pop.cancelTip}" @focus="pop.cancelTip=false" ref="area_cancel" v-model="pop.cancelReason"></textarea>
                    <transition name="fade">
                        <div v-show="pop.cancelTip" class="tip">请输入取消原因</div>
                    </transition>
                </div>
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="pop.cancelFlag = false">取 消</el-button>
                <el-button type="primary" @click="confirm_cancel">确 定</el-button>
            </div>
        </el-dialog>

        <!--不通过验收-->
        <el-dialog @open="openFocus('area_review')" @close="pop.review_rejectReason = ''" title="拒绝验收" :visible.sync="pop.review_rejectFlag">
            <div class="form-item">
                <div class="item-title">任务编号：</div>
                <div class="item-text">{{ detailData.code }}</div>
            </div>
            <div class="form-item">
                <div class="item-title">任务名称：</div>
                <div class="item-text">{{ detailData.task_name }}</div>
            </div>
            <div class="form-item">
                <div class="item-title must">拒绝原因：</div>
                <div class="item-wrap">
                    <textarea :class="{'z-error':pop.review_rejectTip}" @focus="pop.review_rejectTip=false" ref="area_review" v-model="pop.review_rejectReason"></textarea>
                    <transition name="fade">
                        <div v-show="pop.review_rejectTip" class="tip">请输入拒绝原因</div>
                    </transition>
                </div>
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="pop.review_rejectFlag = false">取 消</el-button>
                <el-button type="primary" @click="confirm_review_reject">确 定</el-button>
            </div>
        </el-dialog>

         <!--拒绝取消任务-->
        <el-dialog @open="openFocus('area_cancel')" @close="pop.cancelRejectReason = ''" title="拒绝取消" :visible.sync="pop.cancelRejectFlag">
            <div class="form-item">
                <div class="item-title">任务编号：</div>
                <div class="item-text">{{ detailData.code }}</div>
            </div>
            <div class="form-item">
                <div class="item-title">任务名称：</div>
                <div class="item-text">{{ detailData.task_name  }}</div>
            </div>
            <div class="form-item">
                <div class="item-title must">拒绝原因：</div>
                <div class="item-wrap">
                    <textarea :class="{'z-error':pop.cancelRejectTip}" @focus="pop.cancelRejectTip=false" ref="area_cancel" v-model="pop.cancelRejectReason"></textarea>
                    <transition name="fade">
                        <div v-show="pop.cancelRejectTip" class="tip">请输入拒绝原因</div>
                    </transition>
                </div>
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="pop.cancelRejectFlag = false">取 消</el-button>
                <el-button type="primary" @click="confirm_cancel_reject">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
    export default {
        props:["taskId","buType","detailData",'sub'],
        data(){
            return {
                // fullscreenLoading:false,  //锁屏

                // 一堆弹窗判断器
                pop:{
                    refuseFlag:false,  //拒绝任务  弹窗
                    refuseReason:"",   //拒绝任务  理由
                    refuseTip:false,   //拒绝任务  报错

                    transFlag:false,   //流转任务  弹窗
                    transBuId:"",      //流转bu的id
                    transOpen:false,   //流转bu列表 展开控制器

                    reportFlag:false,  //投诉任务  弹窗
                    reportReason:"",   //投诉任务  理由
                    reportTip:false,   //投诉任务  报错

                    cancelFlag:false,  //取消任务  弹窗
                    cancelReason:"",   //取消任务  理由
                    cancelTip:false,   //取消任务  报错

                    review_rejectFlag:false,  //验收任务失败  弹窗
                    review_rejectReason:"",   //验收任务失败  理由
                    review_rejectTip:false,   //验收任务失败  报错
                    
                    cancelRejectFlag:false,  //拒绝取消任务  弹窗
                    cancelRejectReason:"",   //拒绝取消任务  理由
                    cancelRejectTip:false,   //拒绝取消任务  报错
                },

            }
        },

        computed:{
            task_id(){
                return  this.taskId || this.$crypto.decrypt(this.$route.params.task_id);
            },
            tab_num(){
                switch (this.buType) {
                    case 1:  //发布方
                        return 1;
                
                    case 2:  //接收方
                        return 0;
                }
            },
        },

        methods:{
            jump(key_str){  //跳转对应页面
                this.$store.dispatch("setId",this.task_id);  //记录操作的任务id
                this.$router.push({
                    name:`${key_str}-task`,
                    query:{
                        tab:this.tab_num,
                    }
                });
            },
            openFocus(str){  //弹窗后，表单获得焦点
                setTimeout(()=>{
                    this.$refs[str].focus();
                },0);
            },

            //****发布和保存**
            getSubData() {  //获取提交的表单数据
                let formdata = new FormData();
                formdata.append("template_id", this.sub.tempId);
                formdata.append('sub_bu_id', this.sub.buId);
                formdata.append("task_name", this.sub.taskName);
                formdata.append('task_description', this.sub.taskDescribe);
                formdata.append('task_cycle', parseInt(this.sub.taskCycle));
                // formdata.append("currency_id", this.sub.currencyId);
                formdata.append('currency_amount', parseInt(this.sub.fastBonus));
                for (let i = 0, len = this.sub.uploadDoc.length; i < len; i++) {
                    if (this.sub.uploadDoc[i]) {
                        formdata.append('task_requirement_docs[]', this.sub.uploadDoc[i]);
                    }
                }
                if(this.sub.deldocId.length != 0 ){
                    formdata.append('task_requirement_docs_delete', this.sub.deldocId);
                }
                return formdata;
            },
            save() {  //点击保存按钮
                let res = this.$form.check("task_detail");
                if(!res){
                    return;
                }

                // this.fullscreenLoading = true;
                this.$func.loading(true);

                if( this.task_id == 0 ){   //创建任务
                    console.log("创建 无Id");
                    this.$http.post('api/clerk/task',this.getSubData(),{
                        transformRequest: [function (data) {
                            return data;
                        }]
                    }).then(res=>{
                        if(res.status == 200){
                            console.log(res);   
                            let str = this.$crypto.encrypt(res.res_data);
                            this.$router.replace({
                                name:"task-detail",
                                params:{
                                    task_id:str,
                                }
                            });
                            this.successTip("保存成功");
                        }
                        // this.fullscreenLoading = false;
                        this.$func.loading(false);
                     
                    }).catch(err=>{
                        this.errorTip("出错啦");
                        this.$func.loading(false);
                    });
                }else{   //待发布任务保存  
                    console.log("保存 有Id");
                    this.$http.put('api/clerk/task/' + this.task_id, this.getSubData(), {
                        transformRequest: [function (data) {
                            return data;
                        }]
                    }).then(res => {
                        console.log(res);
                        if(res.status == 200){
                            this.$emit("refresh");
                            this.successTip("保存成功");
                        }
                        this.$func.loading(false);
                    }).catch(error => {
                        console.log(error);
                        this.errorTip("出错啦");
                        this.$func.loading(false);
                    });
                }
            },
            release() {  //点击发布按钮
                let res = this.$form.check("task_detail");
                if(!res){
                    return;
                }

                this.$func.loading(true);
                let myUpdated = this.getSubData();

                if (this.task_id != "0") {
                    myUpdated.append("task_detail_id", this.task_id);
                }

                this.$http.post('api/clerk/task/admin_reviewing_or_sub_picking', myUpdated, {
                    transformRequest: [function (data) {
                        return data;
                    }]
                }).then(res => {
                    // this.fullscreenLoading = false;
                    this.$func.loading(false);
                    if(res.status == 200){
                        let data = res.res_data;
                        console.log(res);
                        // 接收中
                        if(data.category_status == 20 && data.process_status == 201){
                            this.$store.dispatch("setId",data.id);
                            this.$router.push({
                                name:"dealing-task",
                                query:{
                                    tab:1,
                                }
                            });
                            this.successTip("任务已成功发布");
                        }

                        // 审核中
                        if(data.category_status == 10 && data.process_status == 102){
                            this.$store.dispatch("setId",data.id);
                            this.$router.push({
                                name:"start-task",
                            });
                            this.successTip("任务已送往审核");
                        }

                    }
                    
                }).catch(err => {
                    console.log(err);
                    this.errorTip("出错了");
                    // this.fullscreenLoading = false;
                    this.$func.loading(false);
                });

            },


            // ****接收方  butype = 2
            receive() {  //接受任务
                let res = this.$form.check('task_detail');  //检测详情表单
                if(!res){
                    return;
                }
                var url = '/api/clerk/task/sub_processing/' + this.task_id;
               
                this.$func.loading(true);
                this.$http.put(url,{
                    task_assign_user_id : this.sub.person,
                }).then(res => {
                    if(res.status == 200){
                        this.jump("dealing");
                        this.successTip("接收任务成功");
                    }
                    this.$func.loading(false);
                    
                }).catch(error => {
                    this.$func.loading(false);
                    this.errorTip("出错了");
                });
            },
            confirm_refuse() {  //拒绝任务
                let reason = this.pop.refuseReason;
                if( reason == ""){
                    this.pop.refuseTip = true;
                    return;
                }
                
                this.$func.loading(true);
                

                let url = 'api/clerk/task/rejected/' + this.task_id;
                this.$http.put(url,{
                    reason: reason
                }).then(res=>{
                    if(res.status == 200){
                        this.jump("dealing");
                        this.successTip("已拒绝");
                    }
                    this.$func.loading(false);
                    
                }).catch(error =>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                    
                });
            },

            review(){  //提交验收
                this.$func.loading(true);

                let url = "api/clerk/task/pub_reviewing/"+this.task_id;

                this.$http.put(url).then(res => {
                    if(res.status == 200){
                        this.jump("dealing");
                        this.successTip("已提交验收");
                    }
                    this.$func.loading(false);
                }).catch(error => {
                    this.$func.loading(false);
                    this.errorTip("提交失败");
                });
                
            },
            confirm_cancel(){   //申请取消
                let reason = this.pop.cancelReason;
                if( reason == ""){
                    this.pop.cancelTip = true;
                    return;
                }

                this.$func.loading(true);
                let url = "api/clerk/task/pub_canceling/" + this.task_id;
                this.$http.put(url,{
                    reason: reason
                }).then(res=>{
                    if(res.status == 200){
                        this.jump("dealing");
                        this.pop.cancelFlag = false;
                        this.successTip("已申请取消");
                    }
                    this.$func.loading(false);
                }).catch(error =>{
                    this.$func.loading(false);
                    this.errorTip("申请取消失败");
                });
                
            },


            // ******发布方  butype = 1
            confirm_report() {  //投诉
                let reason = this.pop.reportReason;
                if( reason == ""){
                    this.pop.reportTip = true;
                    return;
                }
                
                this.$func.loading(true);
                
                let url = "api/clerk/task/report/" + this.task_id;
                this.$http.put(url,{
                    reason: reason
                }).then(res=>{
                    if(res.status == 200){
                        this.pop.reportFlag = false;
                        this.successTip("已送往投诉");
                        this.jump("dealing");
                    }
                    this.$func.loading(false);
                }).catch(error =>{
                    this.errorTip("投诉失败");
                    this.$func.loading(false);
                });
            },
            stop_task(){  //终止任务
                this.$func.loading(true);

                let url = "api/clerk/task/terminate/"+this.task_id;

                this.$http.put(url).then(res => {
                    if(res.status == 200){
                        this.jump("end");
                        this.successTip("任务已终止");
                    }
                    this.$func.loading(false);
                }).catch(error => {
                    this.$func.loading(false);
                    this.errorTip("出错了");
                });

            },

            review_complete(){  //验收通过
                this.$func.loading(true);
                let url = `api/clerk/task/completed/${this.task_id}`;
                this.$http.put(url).then(res=>{
                    if(res.status == 200){
                        this.jump("end");
                        this.successTip("验收成功");
                    }
                    this.$func.loading(false);
                }).catch(error =>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                });
            },
            confirm_review_reject(){    //验收不通过
                let reason = this.pop.review_rejectReason;
                if( reason == ""){
                    this.pop.review_rejectTip = true;
                    return;
                }

                this.$func.loading(true);
                
                let url = "api/clerk/task/check_rejected/" + this.task_id;
                this.$http.put(url,{
                    reason: reason
                }).then(res=>{
                    if(res.status == 200){
                        this.jump("dealing");
                        this.pop.review_rejectFlag = false;
                        this.successTip("已拒绝验收");
                        
                    }
                    this.$func.loading(false);
                }).catch(error =>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                });
            },

            cancel_agree(){   //同意取消任务
                this.$func.loading(true);
                let url = `api/clerk/task/cancel_pass_by_pub/${this.task_id}`;
                this.$http.put(url).then(res=>{
                    if(res.status == 200){
                        this.jump("dealing");
                        this.successTip("已送往管理员审核");
                    }
                    this.$func.loading(false);
                }).catch(error =>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                });
            },
            confirm_cancel_reject(){  //拒绝取消任务
                let reason = this.pop.cancelRejectReason;
                if( reason == ""){
                    this.pop.cancelRejectTip = true;
                    return;
                }
                this.$func.loading(true);
                let url = "api/clerk/task/cancel_rejected_by_pub/" + this.task_id;
                this.$http.put(url,{
                    reason: reason
                }).then(res=>{
                    if(res.status == 200){
                        this.jump("dealing");
                        this.successTip("已驳回取消请求");
                    }

                    this.pop.cancelRejectFlag = false;
                    this.$func.loading(false);
                    
                }).catch(error =>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                });
            },

            // confirm_trans(){  //流转任务
            //     let bu_id = this.pop.transBuId;

            //     if(!bu_id){
            //         this.errorTip("未选择流转BU");
            //         return ;
            //     }
            //     let url = `api/clerk/task/trans/${this.task_id}`;
            //     this.$http.put(url,{
            //         sub_bu_id:bu_id
            //     }).then(res=>{
            //         this.pop.transFlag = false;
            //         res.end();
            //         this.successTip("流转成功");
            //         this.backRefresh(true);
            //     }).catch(error=>{
            //         console.log(error);
            //         error.end();
            //         this.errorTip();
            //     });

            // },

        },
    }
</script>

<style lang="less" scoped>
    // .button-list{
    //     margin-top:30px;
    // }
</style>




// WEBPACK FOOTER //
// process-btn.vue?4c4b2ac9